import type { FaireProductEntity } from "../../entity_types/product";

export const p_x4nadf34ke: FaireProductEntity = {
  token: "p_x4nadf34ke",
  type: "product",
  name: "Gomacro Organic Macrobar Coconut Almond Choc 12 Pack",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl: "https://cdn.faire.com/fastly/d2fb266ce559a9c619a8e25be3fdefadc49713933a38845666c9fbb51c3b1024.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/927d32ca69cbe31f144071519ec5f9a8210335db04e9ba2a05dd3e7786821df7.jpeg",
    "https://cdn.faire.com/fastly/a1ceca9a45bb619185d7a74ea1a55b01a99e5c92bf4890dbbb4f5002625f579e.jpeg"
  ],
  priceDollars: 50.24,
  description: "\n\nIndulge your taste buds with the perfect blend of coconut, almond butter, and chocolate chips in this convenient snack. Each bar is crafted with sustainably sourced ingredients, ensuring a wholesome treat that aligns with your dietary preferences. Packed with 10 grams of plant-based protein, these bars are perfect for on-the-go energy.\n\n * Organic and vegan-friendly for guilt-free enjoyment \n * Gluten-free and kosher to suit diverse dietary needs \n * Non-GMO ingredients for peace of mind \nWith a case of 12 bars, you can easily stock up and enjoy a nutritious and delicious snack anytime, anywhere.\n",
  tags: [],
  msrpDollars: 100.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:42.984Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
